export const competencies = state => state.competencies;
